export const composeQueryParams = (params = {}) => {
  const query = Object.entries(params)
    .filter(([, value]) => value != null)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value as string)}`)
    .join('&')

  return query ? `?${query}` : ''
}
